import {SubscriptionState} from "./subscription-state";

export const SubscriptionStateLabel: { [key in SubscriptionState]: string } = {
  [SubscriptionState.DRAFT]: 'In aanvraag binnen bedenktermijn',
  [SubscriptionState.PENDING]: 'In aanvraag',
  [SubscriptionState.INACTIVE]: 'Opgezegd',
  [SubscriptionState.CANCELLED]: 'Geannuleerd',
  [SubscriptionState.ACTIVE]: 'Actief',
  [SubscriptionState.PENDING_TERMINATION]: 'Opzegging in behandeling',
  [SubscriptionState.UNKNOWN]: '',
};
